import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { OktaAuthModule, OKTA_CONFIG } from '@okta/okta-angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MyWorkBasketComponent } from './components/my-work-basket/my-work-basket.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms'; 
import { environment } from '../environments/environment';
import { AsyncPipe, CommonModule, DatePipe } from '@angular/common';
import { OktaAuth } from '@okta/okta-auth-js';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTableModule } from '@angular/material/table';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSortModule } from '@angular/material/sort';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withFetch } from '@angular/common/http';
import { RetrievalComponent } from './components/retrieval/retrieval.component';
import { WebUploadComponent } from './components/web-upload/web-upload.component';
import { WorkflowComponent } from './components/workflow/workflow.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { DateAdapter, provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; 
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { UserSystemComponent } from './shared/user-system/user-system.component';
import { DialogComponent } from './shared/dialog/dialog.component';
import { TableModule } from 'primeng/table';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { UserReassignComponent } from './shared/user-reassign/user-reassign.component';
import { DocumentHistoryDialogComponent } from './shared/document-history-dialog/document-history-dialog.component';
import { WorkflowHistoryDialogComponent } from './shared/workflow-history-dialog/workflow-history-dialog.component';
import { SendEmailComponent } from './shared/send-email/send-email.component';
import { ViewAddDocNotesComponent } from './shared/view-add-doc-notes/view-add-doc-notes.component';
import { ViewWorkflowNotesComponent } from './shared/view-workflow-notes/view-workflow-notes.component';
import { DocumentViewerComponent } from './components/document-viewer/document-viewer.component';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { AddAttachmentComponent } from './shared/add-attachment/add-attachment.component';
import { UserPreferenceComponent } from './shared/user-preferences/user-preferences.component';
import { ContactComponent } from './shared/Contacts/contact.component';
import { MatTreeModule } from '@angular/material/tree';
import { DynamicDateAdapter } from './common/dynamic-date-adapter';
import { DirectDocRetrievalComponent } from './shared/direct-doc-retrieval/direct-doc-retrieval.component';
import { PermissionComponent } from './shared/permission/permission.component';
import { VendorInfoComponent } from './components/vendor-info/vendor-info.component';
import { PaymentCodeComponent } from './components/payment-code/payment-code.component';
import { InputTextModule } from 'primeng/inputtext';
import { CalendarModule } from 'primeng/calendar';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { LineItemsGlEntryComponent } from './shared/line-items-gl-entry/line-items-gl-entry.component';
import { AuthInterceptor } from '../gaurds/auth.interceptor';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TooltipModule } from 'primeng/tooltip';
import { SubstitutionComponent } from './components/substitution/substitution.component';
import { UserSubstitutionComponent } from './shared/user-substitution/user-substitution.component';

const oktaAuth = new OktaAuth({
  issuer: environment.okta.issuer,
  clientId: environment.okta.clientId,
  redirectUri: environment.okta.redirectUri,
  scopes: environment.okta.scopes,
});

@NgModule({
  declarations: [
    AppComponent,
    MyWorkBasketComponent, 
    RetrievalComponent,
    WebUploadComponent,
    WorkflowComponent, 
    UserSystemComponent,
    DialogComponent,
    UserReassignComponent,
    DocumentHistoryDialogComponent,
    WorkflowHistoryDialogComponent,
    SendEmailComponent,
    ViewAddDocNotesComponent,
    ViewWorkflowNotesComponent,
    DocumentViewerComponent,
    SafeUrlPipe,
    AddAttachmentComponent,
    DirectDocRetrievalComponent,
    PermissionComponent,
    UserPreferenceComponent,
    ContactComponent,
    VendorInfoComponent,
    LineItemsGlEntryComponent,
    PaymentCodeComponent, 
    SubstitutionComponent, 
    UserSubstitutionComponent
  ],
  imports: [
    HttpClientModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    BrowserAnimationsModule,
    MatSelectModule,
    MatSortModule,
    FormsModule,
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    MatTabsModule,
    MatTableModule,
    MatDialogModule,
    OktaAuthModule,
    MatTreeModule,
    MatExpansionModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDatepickerModule,
    MatToolbarModule,
    MatCheckboxModule,
    MatRadioModule,
    ReactiveFormsModule,
    TableModule,
    CheckboxModule,
    DropdownModule,
    MultiSelectModule,
    MatListModule,
    MatCardModule,
    MatAutocompleteModule,
    InputTextModule,
    ButtonModule,
    TagModule,
    CalendarModule,
    AsyncPipe,
    AutoCompleteModule,
    TooltipModule,
  ],
  providers: [
    { provide: OKTA_CONFIG, useValue: { oktaAuth } },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    provideHttpClient(withFetch()),
    provideClientHydration(),
    provideNativeDateAdapter(),
    DatePipe,
    provideAnimationsAsync(),
    {
      provide: DateAdapter,
      useClass: DynamicDateAdapter
    },
  ],
  exports: [],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
